/* eslint-disable @angular-eslint/component-class-suffix */
import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

import {EnterpriseInfo} from 'shared/dtos/wizard/enterprise-info';

@Component({
  templateUrl: './enterprise-info-completion.dialog.html',
  styleUrl: './enterprise-info-completion.dialog.scss',
  standalone: false
})
export class EnterpriseInfoCompletionDialog implements OnInit {
  enterpriseInfoForm: UntypedFormGroup;
  private formValueSubscription: Subscription;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: EnterpriseInfo
  ) {
    this.enterpriseInfoForm = this.formBuilder.group({
      firma: [data.firma],
      uid: [data.uid],
      fachperson: [data.fachperson]
    });
  }

  ngOnInit(): void {
    this.formValueSubscription = this.enterpriseInfoForm.valueChanges
      .pipe(debounceTime(1000))
      .subscribe({
        next: (changes: EnterpriseInfo) => {
          Object.assign(this.data, changes);
        }
      });
  }
}
